import React, { useEffect } from "react";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import Process from "@/sections/Process";
import Stack from "@/sections/Stack";
import Stats from "@/sections/Stats";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

const Landing = () => {
  useEffect(() => {
    document.title = "aetheria // blockchain dev studio";
  }, []);

  return (
    <main id="top" className="relative min-h-screen bg-black text-white selection:bg-[#00FF41] selection:text-black">
      {/* background grid */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 bg-grid bg-grid-fade opacity-60"
      />
      {/* vignette */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0,255,65,0.08), transparent 60%)",
        }}
      />

      <div className="relative z-10">
        <Nav />
        <Hero />
        <Marquee />
        <Services />
        <Process />
        <Stack />
        <Stats />
        <Contact />
        <Footer />
      </div>
    </main>
  );
};

export default Landing;
